<template>
  <div style="height:100%">
    <login v-if="!isLogin"></login>
    <template v-else>
        <el-container style="height:100%">
          <el-header class="header" style="height:80px">
            <el-container style="height:100%">
              <el-aside width="200px" style="overflow-y: hidden">
                <!-- <img style="margin-left:20px;margin-top:5px" height="90%" src="~@/assets/logo5.png"/> -->
              </el-aside>
              <el-main style="overflow:hidden;">
                <el-row :gutter="20">
                  <el-col :span="16"  style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                      <el-link v-if="outsider.Type==1" icon="el-icon-message-solid" style="line-height:40px;color:white;">
                        Tips：微信转账请选择微信，银行卡转账请选择银行卡，批量上传默认为银行卡转账
                      </el-link>
                      <el-link v-else icon="el-icon-message-solid" style="line-height:40px;color:white;">
                        Tips：审核错误将有一定惩罚，请认真审核
                      </el-link>
                      <span style="color:transparent">-</span>
                  </el-col>
                  <el-col :span="8">
                    <div style="float:right">
                      <div style="float:left;margin-right:20px">
                        <div style="margin-top:-10px;float:left">
                            <!-- <img  height="60px" src="~@/assets/header1.png"> -->
                        </div>
                      </div>
                        <el-link @click="setPwdAction" style="float:left;margin-right:20px;line-height:40px" type="danger">修改密码</el-link>
                    <el-switch
                    @change="setIsOnLine"
                      style="float:left;margin-top:10px;margin-right:20px"
                      v-model="isOnLine">
                    </el-switch>
                      <div style="float:left;text-align:center;width:150px;color:white;border-left:1px solid SteelBlue;border-right:1px solid SteelBlue;margin-right:10px;">
                          <div style="cursor:pointer">
                            <p style="margin:0px;color:white">{{outsider.Phone}}</p>
                            <p style="margin:0px;"><el-tag size="mini" effect="dark" color="black" style="border-color:black">欢迎您，{{outsider.Name}}</el-tag></p>
                          </div>
                      </div>
                      <div style="float:left;"> 
                          <el-tooltip class="item" effect="dark" content="退出登录" placement="bottom">
                            <el-button type="danger" style="margin-top:6px" @click="loginOut" icon="el-icon-switch-button" size="small" circle></el-button>
                          </el-tooltip>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-main>
            </el-container>
          </el-header>
          <el-container style="height:100%">
            <el-aside width="180px">
              <el-menu
              style="height:100%"       
              background-color="#545c64"
              text-color="#fff"
              @select="handleSelect" 
              active-text-color="#D9006C"
                    :default-active="active">
                    <el-menu-item index="1" v-if="outsider.Type==1||outsider.Type==0">
                      <i class="el-icon-money"></i>
                      <span slot="title">出纳转账</span>
                    </el-menu-item>
                    <el-menu-item index="2"  v-else-if="outsider.Type==2||outsider.Type==0">
                      <i class="el-icon-tickets"></i>
                      <span slot="title">任务审核</span>
                    </el-menu-item>
                  </el-menu>
            </el-aside>
            <el-main :style="'height:'+mainHeight+'px'">
              <router-view :outsider="outsider" :isOnLine="isOnLine">
              </router-view>
            </el-main>
          </el-container>
        </el-container>
    </template>

    <el-dialog
    :close-on-click-modal	="false"
  title="修改密码"
  :visible.sync="dialogVisible"
  width="400px">
    <el-form :model="setPwdModel" :rules="rules" ref="ruleForm" style="margin-top:-30px;margin-bottom:-30px">
      <el-form-item label="旧密码"  prop="oldPwd">
        <el-input show-password v-model="setPwdModel.oldPwd"  ></el-input>
      </el-form-item>
      <el-form-item label="新密码"  prop="newPwd">
        <el-input show-password v-model="setPwdModel.newPwd"  ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码"  prop="comfrimPwd">
        <el-input show-password v-model="setPwdModel.comfrimPwd"  ></el-input>
      </el-form-item>
    </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="setPwd">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import login from '@/page/login'
import { accountGetIsOnline,accountSetIsOnLine,accountSetPwd} from '@/request.js'

export default {
  name: 'App',
  components: {
    login
  },
  data() {
    return {
      dialogVisible:false,
      isLogin:false,
      outsider:{},
      mainHeight:0,
      active:'1',
      isOnLine:false,
      setPwdModel:{
        oldPwd:"",
        newPwd:"",
        comfrimPwd:"",
      },
      rules: {
          oldPwd: [
            { required: true, message: '请输入旧密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          newPwd: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],         
          comfrimPwd: [
            { required: true, message: '请确认新密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],
        }
    };
  },
  created() {
    this.mainHeight=document.body.clientHeight-80;
    var token= localStorage.getItem("outsidertoken");
      if(token==undefined){
        this.isLogin=false;
      }else{
        this.isLogin=true;
        this.outsider=JSON.parse(localStorage.getItem("outsider"))
        if(this.outsider.Type==1||this.outsider.Type==0){
          this.$router.push("/index");
          this.active="1";
        }else{
          this.$router.push("/order");
          this.active="2";
        }
    }
  },
  mounted() {
    accountGetIsOnline({},(res)=>{
      this.isOnLine=res.Result;
    });
  },
  methods:{
    setPwdAction(){
      this.dialogVisible=true;
      this.setPwdModel={
        oldPwd:"",
        newPwd:"",
        comfrimPwd:"",
      };
    },
    setPwd(){
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            if(this.setPwdModel.newPwd==this.setPwdModel.comfrimPwd){
              accountSetPwd(this.setPwdModel,(res)=>{
                if(res.IsSuccess){
                    this.$message({
                      message: '修改成功',
                      type: 'success'
                    });
                    this.dialogVisible=false;
                }else{
                  this.$message.error('旧密码不正确');
                }
              })
            }else{
              this.$message.error('两次输入密码不一致');
            }
          } else {
            return false;
          }
        });
    },
    setIsOnLine(){
       accountSetIsOnLine({isOnLine:this.isOnLine},()=>{
          if(this.isOnLine){
              this.$message({
                message: '开始接单了',
                type: 'success'
              });
          }else{
              this.$message({
                message: '停止接单了',
                type: 'success'
              });
          }
       });
     },
      handleSelect(key){
        if(key=="1"){
          this.$router.push({
            path: `/`,
          })
        }
     },
    loginOut(){
      this.isLogin=false;
      localStorage.removeItem("outsidertoken");
      localStorage.removeItem("outsider");
    },
  },
}
</script>
<style scoped>
.header{
  padding:0px;
  background: url('~@/assets/head2.png') no-repeat center 0px;
}
</style>
